/* @flow */
import {get, nth} from 'lodash';
import { nodeAttrs, scrollBy } from './dom';

type Location = { hash: string };

const SLIDE_HASH_REGEX = /^#slide-(\d+)$/;
const SLIDESHOW_TOP_AD_CLASS_NAME = 'ss-ad';

const getSlideIndex = (location: Location): ?number =>
  nth(get(location, 'hash', '').match(SLIDE_HASH_REGEX), 1);

export const getSlideIndexInHash = (location: Location): number =>
  Number(getSlideIndex(location)) || 0;

const getSlideHash = (slideIndex: number): string =>
  slideIndex > 0 ? `#slide-${slideIndex}` : '';

export const getSlideLocation = (
  slideIndex: number,
  location: Location
): Location => ({
  ...location,
  hash: getSlideHash(slideIndex)
});

export const getPreviousSlideLocation = (
  slideIndex: number = 0,
  location: Location
): ?Location =>
  slideIndex > 0 ? getSlideLocation(slideIndex - 1, location) : null;

export const getNextSlideLocation = (
  slideIndex: number = 0,
  location: Location,
  slideCount: number
): ?Location =>
  slideIndex === slideCount ? null : getSlideLocation(slideIndex + 1, location);

export const scrollToTopDesktopAd = (): void => {
  const ssTopAdElement = document.getElementsByClassName(
    SLIDESHOW_TOP_AD_CLASS_NAME
  )[0];
  const containerTop = nodeAttrs(ssTopAdElement).top;
  if (containerTop < 0) {
    scrollBy(0, containerTop);
  }
};

export const refreshAds = (): void => {
  const htlbid = window.htlbid || {};
  htlbid.cmd = htlbid.cmd || [];
  htlbid.cmd.push(function(): void {
    htlbid.forceRefresh(['ad-ss-top', 'ad-right-rail']);
  });
};
